import { useCallback } from 'react';
import { showToast } from '../../utils/toast';
import { listingsService } from '../../api';

// Mirrors mobile Step 1 (sell.tsx). UI collects title/price/isNegotiable too,
// but those are persisted in Step 4 (Location). Here we send only the fields
// the backend's Step 1 handler reads.
export const useVehicleDataHandler = () => {
  const handleNext = useCallback(
    async (formData: Record<string, any>): Promise<boolean> => {
      const required = [
        'title',
        'year',
        'make',
        'model',
        'price',
        'mileage',
        'color',
        'fuelType',
        'transmission',
        'bodyType',
        'condition',
      ];

      for (const f of required) {
        if (!formData[f] && formData[f] !== 0) {
          showToast.error(`Please fill in the ${f} field`);
          return false;
        }
      }

      if (
        Number(formData.year) < 1990 ||
        Number(formData.year) > new Date().getFullYear() + 1
      ) {
        showToast.error('Please enter a valid year');
        return false;
      }

      if (Number(formData.mileage) < 0) {
        showToast.error('Mileage cannot be negative');
        return false;
      }

      const params = new URLSearchParams(window.location.search);
      const id = params.get('id');

      const payload = {
        id: id || undefined,
        step: 1,
        mode: id ? ('update' as const) : ('create' as const),
        data: {
          make: formData.make,
          model: formData.model,
          year: Number(formData.year),
          mileage: Number(formData.mileage),
          fuelType: formData.fuelType,
          transmission: formData.transmission,
          bodyType: formData.bodyType,
          condition: formData.condition,
          color: formData.color,
          countryCode: '+355',
          country: 'Albania',
          isImported: formData.isImported === true,
          importCountry: formData.importCountry || null,
          shippingIncluded: formData.shippingIncluded !== false,
          importAvailability: formData.importAvailability || null,
          estimatedArrivalDate: formData.estimatedArrivalDate || null,
        },
      };

      try {
        const res = await listingsService.upsertStep(payload);
        if (!id && res?.id) {
          const newParams = new URLSearchParams(window.location.search);
          newParams.set('id', res.id);
          window.history.replaceState(
            {},
            '',
            `${window.location.pathname}?${newParams.toString()}`
          );
        }
        showToast.success('Vehicle data saved');
        return true;
      } catch (err) {
        console.error('[LISTING][STEP 1] failed', err);
        showToast.error('Failed to save vehicle data');
        return false;
      }
    },
    []
  );

  return { handleNext };
};
